import { Component, OnInit, HostListener } from '@angular/core';
import { CommonState } from './store/reducers/common.reducer';
import { Store, select } from '@ngrx/store';
import { InitMobileCheckAction } from 'store/actions/common.actions';
import { Observable } from 'rxjs';
import { selectIsMobile } from 'store/selectors/common.selector';
import { MsalService } from '@azure/msal-angular';
import { LoginService } from './account/login/login.service';

@Component({
    selector: 'app-root',
    template: `
    <div class="root-loader" *ngIf="isRedirecting" style="display: flex; justify-content: center; align-items: center; height: 100vh;">
        <mat-spinner></mat-spinner>
    </div>
    <router-outlet *ngIf="!isRedirecting"></router-outlet>
    `
})
export class RootComponent implements OnInit {
    // Get is Mobile from store
    isRedirecting = false;
    private isMobile$: Observable<boolean> = this.store$.pipe(select(selectIsMobile));

    constructor(
        private store$: Store<CommonState>,
        private msalService: MsalService,
        private loginService: LoginService
        ) {
        this.isMobile$.subscribe(isMobile => {
            if (isMobile) {
                document.body.classList.add('mobile');
            }
        });

        // Listen for page visibility changes (detects return from SSO)
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible') {
                const ssoNavigationTime = sessionStorage.getItem('ssoNavigationTime');
                const isLoginPage = window.location.href.toLowerCase().indexOf('account/login') > -1;

                if (ssoNavigationTime && isLoginPage) {
                    const timeSinceNavigation = Date.now() - parseInt(ssoNavigationTime, 10);
                    // If SSO navigation was recent (within last 5 minutes) and on login page, reload
                    if (timeSinceNavigation < 300000) {
                        sessionStorage.removeItem('ssoNavigationTime');
                        window.location.reload();
                    }
                }
            }
        });

        const hash = window.location.hash;
        if (hash && (hash.indexOf('id_token') > -1 || hash.indexOf('access_token') > -1 || hash.indexOf('error') > -1 || hash.indexOf('code') > -1)) {
            this.isRedirecting = true;
        }

        this.msalService.handleRedirectCallback((authError, authResult) => {
            if (authResult) {
                this.isRedirecting = true;
                this.loginService.isAuthenticating = true;
                this.loginService.ssoAuthenticateModel.idToken = authResult.idToken.rawIdToken;
                this.loginService.ssoAuthenticateModel.accessToken = authResult.accessToken;
                this.loginService.ssoAuthenticateModel.email = authResult.account.userName;
                this.loginService.ssoAuthenticate(() => {
                    this.loginService.isAuthenticating = false;
                    this.isRedirecting = false;
                });
              } else if (authError) {
                this.isRedirecting = false;
                console.error('Authentication error:', authError);
                alert('Microsoft login failed. Page will be reloaded. Please, try again!');
                window.location.reload();
              }
        });
    }

    ngOnInit() {
        // Dispatching an action for mobile check
        this.store$.dispatch(InitMobileCheckAction());
    }
 }
